import React, { useState, useEffect } from 'react';
import './SignUpForm.css'
import { Layout, Row, Col, Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Select } from 'antd';
import * as authService from './authService';

const { Option } = Select;
const { Content } = Layout;

const SignUpForm = () => {
  const [professorList, setProfessorList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('register'); // 'register' or 'verify'
  const [email, setEmail] = useState('');

  useEffect(() => {
    axios("/auth/get_professor_list", {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=utf-8" },
    }).then(response => {
      setProfessorList(response.data.professor_list);
    }).catch((err) => {
      const msg = err.response?.data?.message || '교수 목록을 불러오는데 실패했습니다';
      message.warning(msg);
    });
  }, []);

  const onFinish = async (signUpInfo) => {
    if (signUpInfo.password !== signUpInfo.password_confirm) {
      message.warning('비밀번호가 일치하지 않습니다');
      return;
    }

    setLoading(true);
    try {
      // 1. Sign up via backend (Cognito account + email verification code sent)
      const signupResult = await authService.signup(
        signUpInfo.username.trim(),
        signUpInfo.password,
      );

      // 2. Register student profile in backend
      await axios.post('/auth/register_student', {
        cognito_sub: signupResult.user_sub,
        username: signUpInfo.username.trim(),
        name: signUpInfo.name.trim(),
        student_number: signUpInfo.student_number.trim(),
        managing_professor_id: signUpInfo.managing_professor_id,
      });

      setEmail(signUpInfo.username.trim());
      setStep('verify');
      message.success('인증 코드가 이메일로 전송되었습니다. 코드를 입력해주세요.');
    } catch (err) {
      console.error('Signup error:', err);
      const msg = err.response?.data?.message || err.message || '회원가입에 실패했습니다';
      message.warning(msg);
    } finally {
      setLoading(false);
    }
  };

  const onVerify = async (values) => {
    setLoading(true);
    try {
      await authService.confirmEmail(email, values.code);
      message.success('이메일 인증이 완료되었습니다. 로그인해주세요.');
      window.location.href = '/login';
    } catch (err) {
      console.error('Verify error:', err);
      const msg = err.response?.data?.message || err.message || '인증에 실패했습니다';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const onResendCode = async () => {
    try {
      await authService.resendCode(email);
      message.success('인증 코드가 재전송되었습니다');
    } catch (err) {
      const msg = err.response?.data?.message || '코드 재전송에 실패했습니다';
      message.error(msg);
    }
  };

  const getOptions = () => {
    return professorList.map(professor => (
      <Option key={professor.id} value={professor.id}>{professor.name}</Option>
    ));
  };

  return (
    <Layout style={{
      minHeight: '100vh',
      padding: '25px',
    }}>
      <Content>
        <div className="site-layout-background" >
          <Row >
            <Col span={24}>
              <div style={{
                backgroundImage: 'url("/eportfolio_logo.png")',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                width: '100%',
                height: '300px',
              }}>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: '50px' }}>
            <Col span={16} offset={4}>
              {step === 'register' && (
                <Form
                  name="normal_login"
                  className="login-form"
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                >
                  <Form.Item
                    name="username"
                    rules={[{ required: true, message: '이메일 계정을 입력하세요. 마이스누 계정이 권장됩니다.' }]}
                  >
                    <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="이메일 주소 (@snu.ac.kr)" />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[
                      { required: true, message: '비밀번호를 입력하세요' },
                      { min: 8, message: '비밀번호는 8자 이상이어야 합니다' },
                    ]}
                  >
                    <Input
                      prefix={<LockOutlined className="site-form-item-icon" />}
                      type="password"
                      placeholder="비밀번호 (8자 이상)"
                    />
                  </Form.Item>
                  <Form.Item
                    name="password_confirm"
                    rules={[{ required: true, message: '비밀번호 확인을 입력하세요' }]}
                  >
                    <Input
                      prefix={<LockOutlined className="site-form-item-icon" />}
                      type="password"
                      placeholder="비밀번호 확인"
                    />
                  </Form.Item>
                  <Form.Item
                    name="name"
                    rules={[{ required: true, message: '이름을 입력하세요' }]}
                  >
                    <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="이름" />
                  </Form.Item>
                  <Form.Item
                    name="student_number"
                    rules={[{ required: true, message: '학번을 입력해주세요' }]}
                  >
                    <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="학번(ex: 202115501)" />
                  </Form.Item>
                  <Form.Item
                    name="managing_professor_id"
                    rules={[{ required: true, message: '지도교수를 선택해주세요' }]}
                  >
                    <Select placeholder="지도교수를 선택하세요">
                      {getOptions()}
                    </Select>
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit" className="login-form-button" loading={loading}>
                      가입신청
                    </Button>
                  </Form.Item>
                </Form>
              )}

              {step === 'verify' && (
                <>
                  <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>이메일 인증</h2>
                  <p style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <strong>{email}</strong>로 전송된 인증 코드를 입력해주세요.
                  </p>
                  <Form name="verify_code" onFinish={onVerify}>
                    <Form.Item
                      name="code"
                      rules={[{ required: true, message: '인증 코드를 입력하세요' }]}
                    >
                      <Input prefix={<MailOutlined />} placeholder="인증 코드 (6자리)" maxLength={6} />
                    </Form.Item>
                    <Form.Item>
                      <Button type="primary" htmlType="submit" block loading={loading}>
                        인증 확인
                      </Button>
                    </Form.Item>
                    <Form.Item>
                      <Button type="link" onClick={onResendCode} block>
                        인증 코드 재전송
                      </Button>
                    </Form.Item>
                  </Form>
                </>
              )}
            </Col>
          </Row>
        </div>
      </Content>
    </Layout>
  );
};

export default SignUpForm
